export const ANONYMOUS_COOKIE_KEY = 'aId';
export const SESSION_COOKIE_KEY = 'sId';
export const SESSION_COOKIE_KEY_REDIRECT = 'redirectToDesktopCookie';
